import { render, staticRenderFns } from "./KycSDKItem.vue?vue&type=template&id=2cf36f48&scoped=true&"
import script from "./KycSDKItem.vue?vue&type=script&lang=js&"
export * from "./KycSDKItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=2cf36f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf36f48",
  null
  
)

export default component.exports